  // Import the functions you need from the SDKs you need
  import { initializeApp } from "firebase/app";
  import { getFirestore } from "firebase/firestore";
  import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries


const firebaseConfig = {
   apiKey: "AIzaSyCiSTdRB6xOw8TsnPxJZV2EEDfgLW9-O5g",
  authDomain: "ada1-9b734.firebaseapp.com",
  projectId: "ada1-9b734",
  storageBucket: "ada1-9b734.firebasestorage.app",
  messagingSenderId: "588296337694",
  appId: "1:588296337694:web:af64e45fcd3e72e46c710f",
  measurementId: "G-SJ1Q499W1M"
};

// Initialize Firebase

const app = initializeApp(firebaseConfig);
// Export firestore database
// It will be imported into your react app whenever it is needed
export const db = getFirestore(app);
export const storage = getStorage(app);
